module.exports = __webpack_public_path__ + "static/img/tangShiZhuoMian.59af1ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tangShiZhuoMian.jpg
// module id = jznr
// module chunks = 2